export type ServiceIcon =
  | 'drywall'
  | 'hammer'
  | 'paint'
  | 'flooring'
  | 'garage'
  | 'wallpaper'
  | 'stucco'
  | 'ceiling'
  | 'water'
  | 'door'
  | 'tile'
  | 'wrench'

export type Service = {
  id: string
  slug: string
  name: string
  blurb: string
  icon: ServiceIcon
  popular?: boolean
}

export type ServiceLink = {
  slug: string
  name: string
  icon: ServiceIcon
}

export const services: Service[] = [
  {
    id: 'drywall-repair',
    slug: 'drywall-services-las-vegas',
    name: 'Drywall Repair',
    blurb: 'Holes, cracks, dents and doorknob blowouts patched so you can’t find them.',
    icon: 'drywall',
    popular: true,
  },
  {
    id: 'drywall-install',
    slug: 'drywall-installation-las-vegas',
    name: 'Drywall Installation',
    blurb: 'New walls, garage finishing and full tear-outs hung, taped and finished.',
    icon: 'hammer',
  },
  {
    id: 'painting',
    slug: 'painting-services-las-vegas',
    name: 'Interior & Exterior Painting',
    blurb: 'Single rooms to whole homes, with clean lines and real prep work.',
    icon: 'paint',
    popular: true,
  },
  {
    id: 'flooring',
    slug: 'flooring-installation-las-vegas',
    name: 'Flooring Installation',
    blurb: 'Removal and install of LVP, laminate and tile — baseboards included.',
    icon: 'flooring',
    popular: true,
  },
  {
    id: 'water-restoration',
    slug: 'water-restoration-las-vegas',
    name: 'Water Restoration',
    blurb: 'Fast water extraction, drying and rebuild after leaks, floods and burst pipes.',
    icon: 'water',
    popular: true,
  },
  {
    id: 'mold-remediation',
    slug: 'mold-remediation-las-vegas',
    name: 'Mold Remediation',
    blurb: 'Mold found, safely removed and the damaged material replaced so it stays gone.',
    icon: 'wrench',
  },
  {
    id: 'popcorn',
    slug: 'popcorn-ceiling-removal-las-vegas',
    name: 'Popcorn Ceiling Removal',
    blurb: 'Scrape, skim and retexture for a clean, modern ceiling.',
    icon: 'ceiling',
  },
  {
    id: 'stucco',
    slug: 'stucco-services-las-vegas',
    name: 'Stucco Repairs & Patches',
    blurb: 'Desert-sun cracks and impact damage blended into your existing finish.',
    icon: 'stucco',
  },
  {
    id: 'water-damage',
    slug: 'water-damage-repair-las-vegas',
    name: 'Water Damage Repair',
    blurb: 'Leak-damaged walls and ceilings cut out, dried, rebuilt and matched.',
    icon: 'water',
  },
  {
    id: 'texture',
    slug: 'texture-matching-las-vegas',
    name: 'Texture Matching',
    blurb: 'Knockdown, orange peel and smooth finishes matched to the original.',
    icon: 'wrench',
  },
  {
    id: 'wallpaper',
    slug: 'wallpaper-services-las-vegas',
    name: 'Wallpaper Installation',
    blurb: 'Accent walls and full rooms hung straight, with old paper removed.',
    icon: 'wallpaper',
  },
  {
    id: 'garage-door',
    slug: 'garage-door-services-las-vegas',
    name: 'Garage Door',
    blurb: 'Repairs, panel replacement and tune-ups to keep it running quiet.',
    icon: 'garage',
  },
  {
    id: 'doors-trim',
    slug: 'doors-trim-baseboards-las-vegas',
    name: 'Doors, Trim & Baseboards',
    blurb: 'Interior doors hung, casing and baseboards installed and caulked.',
    icon: 'door',
  },
  {
    id: 'tile',
    slug: 'tile-backsplash-las-vegas',
    name: 'Tile & Backsplash',
    blurb: 'Backsplashes, shower surrounds and cracked tile replaced.',
    icon: 'tile',
  },
]

export const serviceLinks: ServiceLink[] = [
  { slug: 'handyman-services-las-vegas', name: 'Handyman Services', icon: 'wrench' },
  { slug: 'drywall-services-las-vegas', name: 'Drywall Services', icon: 'drywall' },
  { slug: 'painting-services-las-vegas', name: 'Painting Services', icon: 'paint' },
  { slug: 'carpentry-services-las-vegas', name: 'Carpentry Services', icon: 'hammer' },
  { slug: 'stucco-services-las-vegas', name: 'Stucco Services', icon: 'stucco' },
  { slug: 'wallpaper-services-las-vegas', name: 'Wallpaper Services', icon: 'wallpaper' },
  { slug: 'drywall-installation-las-vegas', name: 'Drywall Installation', icon: 'hammer' },
  { slug: 'flooring-installation-las-vegas', name: 'Flooring Installation', icon: 'flooring' },
  { slug: 'water-restoration-las-vegas', name: 'Water Restoration', icon: 'water' },
  { slug: 'mold-remediation-las-vegas', name: 'Mold Remediation', icon: 'wrench' },
  { slug: 'water-damage-repair-las-vegas', name: 'Water Damage Repair', icon: 'water' },
  { slug: 'popcorn-ceiling-removal-las-vegas', name: 'Popcorn Ceiling Removal', icon: 'ceiling' },
  { slug: 'texture-matching-las-vegas', name: 'Texture Matching', icon: 'wrench' },
  { slug: 'garage-door-services-las-vegas', name: 'Garage Door Services', icon: 'garage' },
  { slug: 'doors-trim-baseboards-las-vegas', name: 'Doors, Trim & Baseboards', icon: 'door' },
  { slug: 'tile-backsplash-las-vegas', name: 'Tile & Backsplash', icon: 'tile' },
]
